/* unplugin-vue-components disabled */import script from "./CouponPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponPrice.vue?vue&type=script&setup=true&lang=js"

import "./CouponPrice.vue?vue&type=style&index=0&id=51bb31e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bb31e6"]])

export default __exports__